export default "__VITE_ASSET__NvtZF8Zh__"